import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "copyLinkInput",
  type: "text",
  "aria-hidden": "true",
  class: "gfu-countdown__hidden-link"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("span", null, [
    (!$data.success)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "gfu-link gfu-link--inline gfu-link--nofx",
          onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.copyText && $options.copyText(...args)), ["prevent"]))
        }, [
          _createVNode(_component_base_icon, { name: "link" })
        ]))
      : (_openBlock(), _createBlock(_component_tooltip, {
          key: 1,
          ref: "tooltip",
          text: "Copied to clipboard!",
          theme: $props.light ? 'light' : 'default',
          "vertical-position": $props.verticalPosition
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: "gfu-link gfu-link--nofx gfu-link--block gfu-link--inline _tc--accent",
              onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.copyText && $options.copyText(...args)), ["prevent"]))
            }, [
              _createVNode(_component_base_icon, { name: "link" })
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["theme", "vertical-position"])),
    _createElementVNode("input", _hoisted_1, null, 512 /* NEED_PATCH */)
  ]))
}